import Keycloak from 'keycloak-js';
import { createContext } from 'react';

interface AuthContextProps {
  authenticated: boolean;
  keycloak: Keycloak.KeycloakInstance  | null;
}

export const AuthContext = createContext<AuthContextProps>({
  authenticated: false,
  keycloak: null,
});